module.exports = __webpack_public_path__ + "static/img/17.161dfc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/17.jpg
// module id = 288
// module chunks = 0